import { gql } from 'apollo-angular';

const GET_RESPOND_BY_ORG_ID = gql`
  query getRfpsByOrg($organizationId: Long) {
    rfpsByOrg(organizationId: $organizationId) {
      id
      status
      type
      submissionDate
      offersDueDate
      offersReceivedDate
      pricingExpirationDate
      buyer {
        id
        name
        organizationType
      }
      category {
        id
        name
        type
      }
      customSpendDateRange {
        selected
      }
      offers {
        id
        status
        seller {
          id
        }
        contract {
          id
          status
          effectiveDate
        }
      }
      recipients {
        status
        seller {
          id
        }
        alert
        offers {
          id
          status
          seller {
            id
          }
          contract {
            id
            status
            effectiveDate
          }
        }
        responseSubmissionDate
        spend {
          actualSpend
          potentialSpend
          isApproximatedPotentialSpend
        }
      }
    }
  }
`;

export default GET_RESPOND_BY_ORG_ID;
